<header
  class="tw-flex tw-items-center tw-min-h-11 tw-w-full tw-bg-transparent tw-px-5 tw-pt-2 [-webkit-app-region:drag]"
>
  @if (!hideLogo()) {
    <a
      [routerLink]="['/']"
      class="tw-w-28 tw-py-2 tw-self-center tw-block [&>*]:tw-align-top [-webkit-app-region:no-drag]"
    >
      <bit-svg [content]="logo" [ariaLabel]="'appLogoLabel' | i18n"></bit-svg>
    </a>
  }
  <div class="[&:has(*)]:tw-ms-auto [&:has(*)]:tw-py-1.5 [-webkit-app-region:no-drag]">
    <ng-content></ng-content>
  </div>
</header>
